<template>
  <div class="" dir="rtl">
    <div class="vh-100 w-100 mx-0 show">
      <div
        style=""
        class="p-0 h-100 text-white w-sidebar sidebar collapse show"
      >
        <Sidebar />
      </div>
      <div class="main-container col px-0">
        <Navbar />
        <div class="row justify-content-center mx-0">
          <div class="col-md-11 px-0">
            <main class="main px-0 px-md-4 pt-3">
              <slot name="mainView"></slot>
            </main>
            <div class="d-flex justify-content-between align-items-center mt-4 text-sm mb-5 pb-5 px-3">
              <div>
                <div class="copyright">
                  جميع الحقوق محفوظة &copy; {{ new Date().getFullYear() }}
                </div>
                <div class="text-muted mb-3">
                  Provided by <span class="text-white-50">Digital Plus Technology Co. Ltd</span>
                </div>
              </div>
              <div class="footer-links">
                <router-link :to="{ name: 'Terms' }" class="text-white text-decoration-none text-sm card-hover p-2 rounded">
                  شروط وأحكام الاستخدام
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <BottomNavigation />
      </div>
    </div>

    <!-- Modals -->
    <!-- <PlayedTrackInfo /> -->
    <PlayedTracklist />
  </div>
</template>

<script>
// import PlayedTrackInfo from '../../components/Player/PlayedTrackInfo.vue';
import PlayedTracklist from '../../components/Player/PlayedTracklist.vue';
import BottomNavigation from "./BottomNavigation.vue";
import Navbar from "./Navbar.vue";
import Sidebar from "./Sidebar.vue";

export default {
  components: {
    BottomNavigation,
    Navbar,
    Sidebar,
    // PlayedTrackInfo,
    PlayedTracklist,
  },
};
</script>

<style lang="scss">
@use "../../assets/css/mdb.rtl.min";
@use "../../assets/css/custom";
</style>
